  <template>
    <div class="Details">
    <section>
        <div class="x">
            <div class="box">
              <h4 class="title is-4">
                <span>
                  Prompts
                </span>
                <span class="is-pulled-right">
                  {{  model }}
                  <b-button @click="runOrCreatePrompt" class="is-primary"> 
                    Create Prompt
                  </b-button>
                </span>
              </h4>
            </div>

            <div class="box">
                <!-- {{ project }} -->
                <h4 class="title is-4">
                  <span>
                    Prompts
                  </span>
                  <span class="is-pulled-right">
                    
                    <b-button class="is-success"> 
                      Examples
                    </b-button>
                  </span>
                </h4>
            <br>
            
            <div class="columns is-multiline" v-if="project.modelId">
                <div class="column is-one-third">
                
              <b-field label="Model base">
                <b-select expanded v-model="model.prompt_model_base_id" size="" placeholder="Select a model base">
                        <option value="ada">GPT-3 Ada</option>
                        <option value="curie">GPT-3 Curie</option>
                        <option value="davinci">GPT-3 Davinci</option>
                        <option value="bloom">Bloom 173B</option>
                </b-select>
              </b-field>

              </div>
              <div class="column is-one-third">

              <b-field label="Temperature">
                <b-slider expanded size="" :min="0" :max="10" v-model="model.prompt_temperature" ticks></b-slider>
              </b-field>

              </div>
              <div class="column is-one-third">

              <b-field label="Stop Sequence">
                <b-taginput
                  size=""
                  v-model="model.prompt_stop_sequence"
                  placeholder="Add a tag"
                  aria-close-label="Delete this tag">
                </b-taginput>
                
              </b-field>
            </div>
            </div>
            <!-- no prompt mode yet -->
            <div class="columns is-multiline" v-else>
                <div class="column is-one-third">
                
              <b-field label="Model base">
                <b-select expanded v-model="prompt_model_base_id" size="" placeholder="Select a model base">
                        <option value="ada">GPT-3 Ada</option>
                        <option value="curie">GPT-3 Curie</option>
                        <option value="davinci">GPT-3 Davinci</option>
                        <option value="bloom">Bloom 173B</option>
                </b-select>
              </b-field>

              </div>
              <div class="column is-one-third">

              <b-field label="Temperature">
                <b-slider expanded size="" :min="0" :max="10" v-model="prompt_temperature" ticks></b-slider>
              </b-field>

              </div>
              <div class="column is-one-third">

              <b-field label="Stop Sequence">
                <b-taginput
                  size=""
                  v-model="prompt_stop_sequence"
                  placeholder="Add a tag"
                  aria-close-label="Delete this tag">
                </b-taginput>
                
              </b-field>
            </div>
            </div>


            <div class="columns is-multiline">
                <div class="column is-full">
                    <b-field label="Prompt" message="Insert {input} into your prompt to generate with samples">
                        <b-input v-if="project.modelId" v-model="model.prompt_template" rows=10 maxlength="200" type="textarea" ></b-input>
                        <b-input v-else v-model="prompt_template" rows=10 maxlength="200" type="textarea" ></b-input>
                    </b-field>
                </div>
            </div>  

            <b>model:</b>
            {{ model }}
            <br>
            <b>project:</b>
            {{ project }}
            <br>
            <b>projectDocuments:</b>
            {{ projectDocuments }}
            
            <!-- {{ generatePromptConfig() }} -->

            <b-button @click="runOrCreatePrompt" type="is-primary" expanded>Submit</b-button>
            
            
              <br>Samples: {{ documents.length }}
              <div class="" v-if="documents.length">
           
                <b-table 
                        :data="documents"
                        :per-page="5"
                        :total="documents.length"
                        pagination-position="both"
                        width="100%"
                        paginated>

                        <b-table-column width="30%" field="text" label="Sample Input" v-slot="props">
                          <b-input v-model="props.row.text" @input="changeInput(props.row)" rows=5 maxlength="200" type="textarea" ></b-input>
                        </b-table-column>
                        <b-table-column width="30%" field="prompt" label="Prompt" v-slot="props">
                          <b-input disabled :value="getPrompt(props.row.text)" rows=5  maxlength="200" type="textarea"></b-input>
                        </b-table-column>
                        <b-table-column width="30%" field="label" label="Completion" v-slot="props">
                                      
                            <b-input disabled v-model="props.row.model_prediction" rows=5  maxlength="200" type="textarea"></b-input>
                              
                        </b-table-column>
                        <!-- <b-table-column width="100%" field="label" label="Label" sortable v-slot="props">
                          
                        </b-table-column> -->
                        
                </b-table>
              
              </div>
            </div>
            
        </div>
        
    </section>
    
    </div>

  
    
</template>
<script>

import TrainModel from '@/components/TrainModel.vue'

export default {
     props: ["project", "modelId", "projectDocuments", "currentUser"],
     name: "Uploads",
     data: function() {
    return {
        viewFilter: (this.$route.query.f == 'errors')?'issues':'all',
        viewOptions: ['all', 'labeled', 'unlabeled', 'issues'],
        versions: false,
        checkboxCustom: [],
        selected: {text: false, label: 'unlabeled'},
        newLabel: false,
        selectedVersion: 'v1',
        animated: true,
        candidateLabels: [(1,1),(2,3)],
        isModalTrainCreateOpen: false,
        labelKeys: [],
        options: {
        
        },
        total: 0,
        predicted: 'any',
        given: 'any',
        search: null,
        sortBy: null,
        documents: null,
        prompt_template: "write instructions... {input}",
        prompt_temperature: 5,
        prompt_stop_sequence: ["\\n", "#"],
        prompt_model_base_id: "ada"
    }},
    components: {
      "modal-train": TrainModel
    },
    computed: {
      model() {
          return this.$store.state.currentModel
      },
     },
     methods: {
      generatePromptConfig(){
        
        return {
          template: this.model.prompt.template || this.prompt_template,
          temperature: this.model.prompt.temperature || this.prompt_temperature,
          stopSequence: this.model.prompt.stopSequence || this.prompt_stop_sequence,
          modelBase: this.model.prompt.modelBase || this.prompt_model_base_id
        }

      },
      getPrompt(input){
        if(this.model.prompt.template){
          return this.model.prompt.template.replace("{input}", input)
        }
      },
      changeFilter(){

        this.documents = this.getDocuments()
      },
      changeInput(row){
          
        const toUpdate = {
            projectId: this.project.id,
            docId: row.docId,
            update: {
                text: row.text
            }
        }

        console.log(toUpdate)

        this.$store.dispatch("updateProjectDocuments", 
            toUpdate
        );
      },
      changeCompletion(doc){


        const toUpdate = {
            projectId: this.project.id,
            docId: doc.dataId,
            update: {
                model_prediction: doc.model_prediction
            }
        }

        this.$store.dispatch("updateProjectDocuments", 
            toUpdate
        );
      },
      getDocuments(){
        return this.projectDocuments
      },
      openLoading() {
                let isFullPage = true
                const loadingComponent = this.$buefy.loading.open({
                    container: isFullPage ? null : this.$refs.element.$el
                })
                setTimeout(() => loadingComponent.close(), 5 * 1000)
      },
      async invoke(input) {

          this.isLoading = true
          
          const payload = {
            userId: this.$firebase.auth().currentUser.uid, 
            modelId: this.project.modelId, 
            text: input,
            hub: true
          }
          
          const result = await this.$store.dispatch("getModelInference", payload);
          return result["prediction"]
      },
      async runPrompt(projectDocuments){
        
        const doc = projectDocuments.slice(0, 4)

        let content = []
        
        for(var i in doc) {
          
          let text = doc[i]['text']
          
          doc[i]['model_prediction'] = await this.invoke(text)
          
          this.changeCompletion(doc[i])
        }
        
      },
      async runOrCreatePrompt(){

        if (this.project.modelId == undefined){
          await this.createPrompt()
        } else {
          await this.updatePrompt()
        }

        await this.runPrompt(this.projectDocuments)
        
      },
      async updatePrompt(){
        this.$buefy.notification.open('Updating prompt...')
        const updateModel = {
          modelId: this.project.modelId,
          update: {
            prompt: 
                this.generatePromptConfig()
            }
        }
        
        this.$store.dispatch("updateModel",
          updateModel
        );
      },
      async createPrompt(){

            this.$buefy.notification.open('Creating prompt...')
            
            const model = {
                type: 'prompt',
                projectId: this.project.id,
                datasetId: this.project.datasetId,
                prompt: this.generatePromptConfig()
            }

            var newDoc = this.$store.dispatch("createModel",
                model
            );

            newDoc.then(newModelId => {
                
                if(this.project.models != undefined){
                  this.project.models.push(newModelId)
                } else {
                  this.project.models = [newModelId]
                }

                const addModelToProject = {
                  projectId: this.project.id,
                  add: {
                    models: this.project.models,
                    modelId: newModelId
                  }
                }
                this.$store.dispatch("addModelToProject",
                  addModelToProject
                );

                this.$buefy.notification.open('Done!')
            })
        }
     },
     created() {

      this.$store.dispatch("currentModel", this.modelId);

      this.documents = this.getDocuments()
        
     }
   };
</script>

<style lang="scss" scoped>
.boards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;

  .board {
    cursor: pointer;
    border: solid 1px #e6e4e4;
    border-radius: 4px;

    &:hover {
      background: #fafafa;
    }

    .info {
      padding: 16px;

      .name {
        display: block;
        margin-bottom: 8px;
        text-transform: capitalize;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin: 0;
        margin-bottom: 8px;
        overflow: hidden;
      }
    }
  }
}
</style>